export default function(el) {
  let params = {};
  let recordId = el.attr('data-record-id');
  let recordType = el.attr('data-record-type');
  let frameworkId = el.attr('data-framework-id');
  let benchmarkPortfolioIds = el.attr('data-benchmark-portfolio-ids');
  let benchmarkIssuerIds = el.attr('data-benchmark-issuer-ids');
  let reportId = el.attr('data-report-id');
  let reportToken = el.attr('data-report-token');
  let dashboardId = el.attr('data-dashboard-id');
  let inclusionId = el.attr('data-inclusion-id');
  let fromDate = el.attr('data-from-date');
  let order = el.attr('data-order');
  params['record_id'] = recordId;
  params['record_type'] = recordType;
  if (typeof frameworkId !== 'undefined') {params['framework_id'] = frameworkId}
  if (typeof benchmarkPortfolioIds !== 'undefined') {params['benchmark_portfolio_ids'] = benchmarkPortfolioIds}
  if (typeof benchmarkIssuerIds !== 'undefined') {params['benchmark_issuer_ids'] = benchmarkIssuerIds}
  if (typeof reportId !== 'undefined') {params['report_id'] = reportId}
  if (typeof reportToken !== 'undefined') {params['report_token'] = reportToken}
  if (typeof dashboardId !== 'undefined') {params['dashboard_id'] = dashboardId}
  if (typeof inclusionId !== 'undefined') {params['inclusion_id'] = inclusionId}
  if (typeof fromDate !== 'undefined') {params['from_date'] = fromDate}
  if (typeof order !== 'undefined') {params['order'] = order}

  // Set any additional params based on any filter attributes
  $.each(el.data(), function(key, val) {
    if (key.indexOf('filter') !== -1) {
      let k = key.replace("filters", "")
      k = k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
      k = k.slice(1);
      params[k] = val
    }
  })

  return params;

}